import axios from "axios";
import authHeader from '../../../authheader'

const PEAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPeApplication";

const getEducationRecords = (applicationId) => {
    return axios.get(`${PEAPPLICATIONURL}/educationrecords`, { headers: authHeader(), params:{ applicationId} });
}
const getApprovedCourseRecords = (applicationId) => {
    return axios.get(`${PEAPPLICATIONURL}/approvedcompletedcourses`, { headers: authHeader(), params:{ applicationId} });
}
const getNonApprovedCourseRecords = (applicationId) => {
    return axios.get(`${PEAPPLICATIONURL}/notapprovedcompletedcourses`, { headers: authHeader(), params: { applicationId } });
}
const postEducationRecord = (data) => {
    return axios.post(`${PEAPPLICATIONURL}/educationrecord`, data, { headers: authHeader() });
}
const postApprovedCourseRecord = (data) => {
    return axios.post(`${PEAPPLICATIONURL}/approvedcompletedcourse`, data, { headers: authHeader() });
}
const postNonApprovedCourseRecord = (data) => {
    return axios.post(`${PEAPPLICATIONURL}/notapprovedcompletedcourse`, data, { headers: authHeader() });
}
export default {
    getEducationRecords,
    getNonApprovedCourseRecords,
    getApprovedCourseRecords,
    postEducationRecord,
    postApprovedCourseRecord,
    postNonApprovedCourseRecord
}